// Profile service - handles all profile-related API calls
import api from './api';

export const profileService = {
  // Get current user's profile
  getMyProfile: async () => {
    const response = await api.get('/profile');
    return response.data;
  },

  // Get user profile by ID
  getUserProfile: async (userId) => {
    const response = await api.get(`/profile/${userId}`);
    return response.data;
  },

  // Get user profile by custom URL
  getUserProfileByUrl: async (customUrl) => {
    const response = await api.get(`/profile/url/${customUrl}`);
    return response.data;
  },

  // Update profile
  updateProfile: async (profileData) => {
    const response = await api.put('/profile', profileData);
    return response.data;
  },

  // Upload profile picture
  uploadProfilePicture: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/upload/profile-picture', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Add work experience
  addWorkExperience: async (experienceData) => {
    const response = await api.post('/profile/experience', experienceData);
    return response.data;
  },

  // Update work experience
  updateWorkExperience: async (id, experienceData) => {
    const response = await api.put(`/profile/experience/${id}`, experienceData);
    return response.data;
  },

  // Delete work experience
  deleteWorkExperience: async (id) => {
    const response = await api.delete(`/profile/experience/${id}`);
    return response.data;
  },

  // Add education
  addEducation: async (educationData) => {
    const response = await api.post('/profile/education', educationData);
    return response.data;
  },

  // Update education
  updateEducation: async (id, educationData) => {
    const response = await api.put(`/profile/education/${id}`, educationData);
    return response.data;
  },

  // Delete education
  deleteEducation: async (id) => {
    const response = await api.delete(`/profile/education/${id}`);
    return response.data;
  },

  // Add project
  addProject: async (projectData) => {
    const response = await api.post('/profile/projects', projectData);
    return response.data;
  },

  // Update project
  updateProject: async (id, projectData) => {
    const response = await api.put(`/profile/projects/${id}`, projectData);
    return response.data;
  },

  // Delete project
  deleteProject: async (id) => {
    const response = await api.delete(`/profile/projects/${id}`);
    return response.data;
  },

  // Add skill
  addSkill: async (skillName) => {
    const response = await api.post('/profile/skills', { skill_name: skillName });
    return response.data;
  },

  // Delete skill
  deleteSkill: async (id) => {
    const response = await api.delete(`/profile/skills/${id}`);
    return response.data;
  },

  // Add certification
  addCertification: async (certificationData) => {
    const response = await api.post('/profile/certifications', certificationData);
    return response.data;
  },

  // Delete certification
  deleteCertification: async (id) => {
    const response = await api.delete(`/profile/certifications/${id}`);
    return response.data;
  },
};

export default profileService;
